"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureArray = void 0;
var lodash_1 = require("lodash");
/**
 * Makes sure that value ends up being array if not already an array
 * @param input
 */
function ensureArray(input) {
    if ((0, lodash_1.isNil)(input)) {
        return [];
    }
    return Array.isArray(input) ? input : [input];
}
exports.ensureArray = ensureArray;
